import colors from "assets/theme/base/colors";

// PorterIQ branded gradient background
// Using brand accent colors from designTokens: blue #2563eb, purple #7c3aed

const { info, dark } = colors;

export default {
  html: {
    scrollBehavior: "smooth",
    background: "transparent",
    fontSize: "90%", // ~14.4px base — scales all rem-based typography to match zoom 0.9
    // Firefox scrollbar
    scrollbarWidth: "thin",
    scrollbarColor: `rgba(147, 148, 178, 0.8) rgba(8, 10, 22, 0.85)`,
  },

  body: {
    scrollbarColor: "rgba(147, 148, 178, 0.8) transparent",
    background: `
      radial-gradient(circle at 30% 30%, rgba(37, 99, 235, 0.7) 0%, transparent 40%),
      radial-gradient(circle at 70% 70%, rgba(124, 58, 237, 0.6) 0%, transparent 40%),
      radial-gradient(circle at 80% 20%, rgba(34, 211, 238, 0.35) 0%, transparent 30%),
      radial-gradient(circle at 20% 80%, rgba(167, 139, 250, 0.35) 0%, transparent 30%),
      linear-gradient(135deg, #010204 0%, #03050f 40%, #050815 100%)
    `,
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundAttachment: "fixed",
    fontFamily: '"Sora", "Helvetica", "Arial", sans-serif',
    animation: "bgPulse 12s ease-in-out infinite",
  },

  "@keyframes bgPulse": {
    "0%, 100%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.8,
    },
  },

  // WebKit scrollbar styles
  "*::-webkit-scrollbar": {
    width: "8px !important",
    height: "8px !important",
    display: "block !important",
  },

  "html::-webkit-scrollbar-track": {
    background: "rgba(8, 10, 22, 0.9) !important",
    margin: "4px 0 !important",
  },

  "*::-webkit-scrollbar-track": {
    background: "transparent !important",
    margin: "4px 0 !important",
  },

  "*::-webkit-scrollbar-thumb": {
    background: "rgba(147, 148, 178, 0.8) !important",
    borderRadius: "20px !important",
    minHeight: "40px !important",
    transition: "all 0.2s ease-in-out !important",
  },

  "*::-webkit-scrollbar-thumb:hover": {
    background: "rgba(147, 148, 178, 1) !important",
  },

  // Ensure rounded corners in Chromium browsers
  "*:not(html)::-webkit-scrollbar-thumb": {
    border: "2px solid transparent !important",
    backgroundClip: "padding-box !important",
    WebkitBorderRadius: "20px !important",
    borderRadius: "20px !important",
  },

  "*::-webkit-scrollbar-corner": {
    background: "transparent !important",
  },

  "*::-webkit-scrollbar-button": {
    display: "none !important",
  },

  // Hide scrollbar for Chrome, Safari and Opera on elements that don't need it
  ".no-scrollbar::-webkit-scrollbar": {
    display: "none !important",
  },

  // Hide scrollbar for IE, Edge and Firefox on elements that don't need it
  ".no-scrollbar": {
    "-ms-overflow-style": "none !important",
    "scrollbar-width": "none !important",
  },

  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },

  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },

  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },

  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};
